var map = {
	"./border-bg-sm.png": 1389,
	"./border-bg.png": 1390,
	"./btn-active.png": 1391,
	"./cny-flower-1.webp": 1392,
	"./cny-flower-2.webp": 1393,
	"./cny-mobile-bg.webp": 1394,
	"./content-deco-1.webp": 1395,
	"./content-deco-2.webp": 1396,
	"./content-deco-3.webp": 1397,
	"./content-deco-4.webp": 1398,
	"./content-deco-5.webp": 1399,
	"./deposit-icon.webp": 1400,
	"./home-icon-active.webp": 1401,
	"./home-icon.webp": 1402,
	"./live-icon-active.webp": 1403,
	"./live-icon.webp": 1404,
	"./master-bg.png": 1405,
	"./me-icon-active.webp": 1406,
	"./me-icon.webp": 1407,
	"./platform.webp": 1408,
	"./product-overview-bg.webp": 1409,
	"./promos-icon-active.webp": 1410,
	"./promos-icon.webp": 1411,
	"./sponsor-icon-active.webp": 1412,
	"./sponsor-icon.webp": 1413,
	"./title-deco-bg.webp": 1414,
	"./title-deco-left.webp": 1415,
	"./title-deco-right.webp": 1416,
	"./vip-icon-active.webp": 1417,
	"./vip-icon.webp": 1418,
	"./withdraw-icon.webp": 1419,
	"./wwr-bg.webp": 1420,
	"./wwr-img.webp": 1421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;